import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import getMergeCartsOptions from '@nike/shop-apis/buy/carts/v2/merge/get-options';
import getWebShellClientLocale from '@nike/shop-apis/utils/get-webshellclient-locale';
import trackEvent from "../../analytics/track-event";
var mergeCarts = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _shellLocale$country, _shellLocale$langRegi;
    var queryClient, _ref$validateOnly, validateOnly, shellLocale, country, langLocale, localeForCurrency, data, _t;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          queryClient = _ref.queryClient, _ref$validateOnly = _ref.validateOnly, validateOnly = _ref$validateOnly === void 0 ? false : _ref$validateOnly;
          shellLocale = getWebShellClientLocale();
          country = (_shellLocale$country = shellLocale.country) === null || _shellLocale$country === void 0 ? void 0 : _shellLocale$country.toUpperCase();
          langLocale = shellLocale === null || shellLocale === void 0 || (_shellLocale$langRegi = shellLocale.langRegion) === null || _shellLocale$langRegi === void 0 ? void 0 : _shellLocale$langRegi.toLowerCase().replace('-', '_');
          localeForCurrency = shellLocale === null || shellLocale === void 0 ? void 0 : shellLocale.hreflang;
          _context.prev = 1;
          _context.next = 2;
          return queryClient.getMutationCache().build(queryClient, getMergeCartsOptions({
            queryClient: queryClient,
            validateOnly: validateOnly
          })).execute();
        case 2:
          data = _context.sent;
          trackEvent('nike-shop-cart-merged', null, {
            country: country,
            langLocale: langLocale,
            localeForCurrency: localeForCurrency
          });
          _context.next = 4;
          break;
        case 3:
          _context.prev = 3;
          _t = _context["catch"](1);
          console.warn('Cart merge skipped:', _t.message); // eslint-disable-line no-console
        case 4:
          return _context.abrupt("return", data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 3]]);
  }));
  return function mergeCarts(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export default mergeCarts;